import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { HashRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import { CustomCSS } from './components/Style/Custom.CSS';


// Maintain root instances (important for Liferay SPA)
const rootMap = new Map();

function renderComponent(element) {
  if (!element) return;

  // Prevent duplicate mounting
  if (!rootMap.has(element)) {
    const root = createRoot(element);

    root.render(
      <React.StrictMode>
        <Router>
          <Provider store={store}>
            <App />
            <CustomCSS />
          </Provider>
        </Router>
      </React.StrictMode>
    );

    rootMap.set(element, root);
  }
}

// Custom Element
class WebComponent extends HTMLElement {
  connectedCallback() {
  
    renderComponent(this);
  }

  disconnectedCallback() {
    //  DO NOT unmount (Liferay SPA reuses DOM)
  }
}

const elementId = "pms-onboarding-element";

// Register custom element
if (!customElements.get(elementId)) {
  customElements.define(elementId, WebComponent);
}

// Initial load
document.addEventListener("DOMContentLoaded", () => {
  const el = document.querySelector("pms-onboarding-element");
  renderComponent(el);
});

//  Liferay SPA navigation support (CRITICAL)
window?.Liferay?.on("endNavigate", () => {
  const el = document.querySelector("pms-onboarding-element");
  renderComponent(el);
});